module.exports = __webpack_public_path__ + "fonts/Inter-500-greek-ext34.2329210.woff2";